import React from "react";
import { useTranslation } from "react-i18next";
import Card from '../../../../../components/Card';

interface StatsProps {
  data: any
}

const Stats: React.FC<StatsProps> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div className="row g-4 mb-6">
      <Card
        title={t('customers.list.pageTexts.stats.titles.total')}
        value={data.total_customers ?? 0}
        description={t('customers.list.pageTexts.stats.descriptions.total')}
        icon="ri-group-line ri-26px"
        variant="primary"
        wrapperClassName="col-sm-6 col-xl-3"
      />
      <Card
        title={t('customers.list.pageTexts.stats.titles.active')}
        value={data.active_customers ?? 0}
        description={t('customers.list.pageTexts.stats.descriptions.active')}
        icon="ri-group-line ri-26px"
        variant="success"
        wrapperClassName="col-sm-6 col-xl-3"
      />
      <Card
        title={t('customers.list.pageTexts.stats.titles.inActive')}
        value={data.inactive_customers ?? 0}
        description={t('customers.list.pageTexts.stats.descriptions.inActive')}
        icon="ri-group-line ri-26px"
        variant="danger"
        wrapperClassName="col-sm-6 col-xl-3"
      />
    </div>
  );
}

export default Stats;